import api from '../api';

async function fetchDistricts() {
    const response = await api.get('districts');
    return response.data;
}

async function fetchCities(params) {
    const response = await api.get('cities', { params });
    return response.data;
}

export { fetchDistricts, fetchCities };
